import { render, staticRenderFns } from "./DistributionConfiguration.vue?vue&type=template&id=a163d33e&scoped=true&"
import script from "./DistributionConfiguration.vue?vue&type=script&lang=js&"
export * from "./DistributionConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DistributionConfiguration.vue?vue&type=style&index=0&id=a163d33e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a163d33e",
  null
  
)

export default component.exports